import {defineConfig} from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const {handleResponse} = utilsService

export const geoService = {
    getApiPath,
    getLatLongByAddress,
    getLocationByAddress,
    getProvinceByRegion,
    getMunicipalityByProvince,
    getZipCodeByMunicipalityIstatCode,
    getMunicipalityByCoordinates,
};

const {apiUrl, apiVer} = defineConfig.GEO_SERVICE;

function getApiPath(){
  const version = (apiVer !== null ? ("/" + apiVer) : "");
  return (apiUrl + version);
}

function getLatLongByAddress(address) {
  const url = getApiPath() + "/georegistry/getLatLongByAddress?address=" + address;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}


//GEOSERVICE : 27/08/2024 Che macari è u' 25 

function getLocationByAddress(address) {
  const url = getApiPath() + "/georegistry/location/" + address;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getProvinceByRegion(region) {
  const url = getApiPath() + "/georegistry/getProvinceByRegion?region=" + region;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getMunicipalityByProvince(province) {
  const url = getApiPath() + "/georegistry/getMunicipalityByProvince?province=" + province;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getZipCodeByMunicipalityIstatCode(istatCode) {
  const url = getApiPath() + "/georegistry/getZipCodeByMunicipalityIstatCode?municipalityIstatCode=" + istatCode;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getMunicipalityByCoordinates(lat, long) {
  const url = getApiPath() + "/georegistry/location/" + lat + "/" + long;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}
